import React from 'react'
import { Box, Typography } from '@mui/material'
import { ViewDayOutlined } from '@mui/icons-material'
import theme from '../../theme'

type Props = {
  contentCategoryValue?: string | null
}

const ContentCategory = ({ contentCategoryValue }: Props) => (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        color: '#ADACA8',
        backgroundColor: theme.palette['sage-50'],
        height: '24px',
        borderRadius: theme.borders['rounded-8']
      }}
    >
      <ViewDayOutlined
        sx={{
          color: 'inherit',
          fontSize: '20px'
        }}
      />
      {contentCategoryValue && (
      <Typography
        variant="ui-2"
        color={theme.palette['sage-900']}
        sx={{ paddingLeft: theme.space['8'] }}
      >
        {`${contentCategoryValue}`}
      </Typography>
      )}
    </Box>
)

export default ContentCategory
